export default __webpack_public_path__ + "static/media/leadhouse.9e43f5be.png";